module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2019/december-a277e3c6b1b0e3c2c76b19c55b0552d3.png";